(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olivalley-experience"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit',event=>{const form=event.target;if(!form.matches('[data-flavour-quiz]'))return;event.preventDefault();const data=new FormData(form);let result=data.get('flavour');if(data.get('use')==='both'&&result!=='bold')result='both';for(const link of form.querySelectorAll('[data-result]'))link.hidden=link.dataset.result!==result;});

  } catch(e) { console.error(e); }
})();
})();
